async function saveSearch(_ref) {
  let {
    data,
    dispatch,
    personalization,
    userDuck,
    searchIds = []
  } = _ref;
  const saveEvent = await personalization.saveSearchItem(data);
  switch (saveEvent.cacheType) {
    case 'remote':
      {
        if (saveEvent.bookmark.isSaved) {
          if (!saveEvent.bookmark.isExisting) {
            dispatch(userDuck.creators.showUpdateSavedSearch({
              bookmark: saveEvent.bookmark,
              phone: saveEvent.phone
            }));
            dispatch(userDuck.creators.setSavedSearchItem({
              ...saveEvent.bookmark
            }));
            if (saveEvent.bookmark.id) {
              dispatch({
                type: userDuck.types.ADD_SAVED_SEARCH_ITEM,
                payload: saveEvent.bookmark.id
              });

              // update local storage only when save was successful
              searchIds.push(saveEvent.bookmark.id);
              personalization.updateUserProfileCache({
                searchIds
              });
            }
          }
        } else {
          if (saveEvent.messages && saveEvent.messages.error) {
            // alert user only when server error is available
            dispatch(userDuck.creators.setGlobalAlert({
              key: 'serverFailure',
              message: saveEvent.messages.error
            }));
          }

          // remove locally saved item since we failed
          dispatch({
            type: userDuck.types.REMOVE_SAVED_SEARCH_ITEM
          });
        }
        break;
      }
    case 'local':
      {
        // TODO: Quick Save Search?
        break;
      }
    default:
  }
  return saveEvent;
}
export default function saveSearchActionCreator(userDuck, personalization) {
  return _ref2 => {
    let {
      data = {},
      onSaveSuccess = () => {},
      message = {}
    } = _ref2;
    return async (dispatch, getState) => {
      try {
        const user = typeof getState().toJS === 'function' ? getState().get('user') : getState().user;
        const searchIds = userDuck.selectors.getSavedSearchIds({
          user
        });

        // TODO: check if user is signed in or not, show registration screen if user is not signed in
        // open sign in screen then save search
        const response = await saveSearch({
          data,
          dispatch,
          searchIds,
          personalization,
          userDuck
        });
        onSaveSuccess(response);
      } catch (error) {
        throw Error(error);
      }
    };
  };
}